// docs for router https://github.com/thepassle/app-tools/blob/master/router/README.md

import { html } from 'lit';

if (!(globalThis as any).URLPattern) {
  await import("urlpattern-polyfill");
}

import { Router } from '@thepassle/app-tools/router.js';
import { lazy } from '@thepassle/app-tools/router/plugins/lazy.js';

import './pages/app-home.js';
import { catchAllRouterPath, resolveRouterPath } from './lib/router-path.js';

export const router = new Router({
  routes: [
    {
      path: resolveRouterPath(),
      title: 'Yes We Can LLC',
      render: () => html`<app-home></app-home>`
    },
    {
      path: resolveRouterPath('about'),
      title: 'About — Yes We Can LLC',
      plugins: [
        lazy(() => import('./pages/app-about/app-about.js')),
      ],
      render: () => html`<app-about></app-about>`
    },
    {
      path: resolveRouterPath('contact'),
      title: 'Contact — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-contact.js'))],
      render: () => html`<app-contact></app-contact>`
    },
    {
      path: resolveRouterPath('terms'),
      title: 'Terms of Use — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-terms.js'))],
      render: () => html`<app-terms></app-terms>`
    },
    {
      path: resolveRouterPath('privacy'),
      title: 'Privacy Policy — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-privacy.js'))],
      render: () => html`<app-privacy></app-privacy>`
    },
    {
      path: resolveRouterPath('blog'),
      title: 'Blog — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-blog-index.js'))],
      render: () => html`<app-blog-index></app-blog-index>`
    },
    {
      path: resolveRouterPath('blog/:slug'),
      title: 'Blog — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-blog-post.js'))],
      render: () => html`<app-blog-post></app-blog-post>`
    },
    {
      path: resolveRouterPath('services'),
      title: 'Services — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-services-index.js'))],
      render: () => html`<app-services-index></app-services-index>`
    },
    {
      path: resolveRouterPath('services/:slug'),
      title: 'Services — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-service-seo.js'))],
      render: () => html`<app-service-seo></app-service-seo>`
    },
    {
      path: resolveRouterPath('new-page'),
      title: 'new page',
      plugins: [
        lazy(() => import('./pages/new-page.js')),
      ],
      render: () => html`<new-page></new-page>`
    },
    {
      path: catchAllRouterPath(),
      title: 'Page not found — Yes We Can LLC',
      plugins: [lazy(() => import('./pages/app-not-found.js'))],
      render: () => html`<app-not-found></app-not-found>`
    }

  ]
});

export { resolveRouterPath };
